import { render } from "./DetailsCard.vue?vue&type=template&id=59321f76&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"

import "./DetailsCard.vue?vue&type=style&index=0&id=59321f76&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59321f76"]])

export default __exports__